<template>
  <div>
    <h1>Order</h1>
    <el-row style="margin-bottom: 20px;">
      <el-col :span="12" :offset="6">
        <el-card shadow="never">
          <el-row :gutter="20" style="margin-bottom: 20px;">
            <el-col :span="14">
              <q-select
                v-model="shopSearch"
                placeholder="ค้นหาชื่อร้าน, อีเมล, Shop Code, User Code"
                class="q-select-search-all-shop"
                :disable="selectAllShopSearch"
                :loading="loadingSearch"
                outlined
                use-input
                fill-input
                hide-selected
                input-debounce="800"
                :options="allShopData"
                @filter="remoteMethodSearchShop"
              >
                <template v-slot:option="scope">
                  <q-list bordered class="q-select-search-all-shop-option">
                    <q-item-label header class="q-item-label-font-style">{{ scope.opt.userCode }}</q-item-label>

                    <q-item
                      v-for="(item, subIndex) in scope.opt.shops" :key="`${subIndex}-${item.id}`"
                      clickable
                      v-ripple
                      v-close-popup
                      @click="handleSelect(item)"
                    >
                      <q-item-section>
                        <q-item-label>
                          <div class="q-item-label-text-overflow q-item-label-font-style">
                            <span v-html="$options.filters.highlight(item.name, shopSearch)">{{ item.name }}</span>
                            - <span v-html="$options.filters.highlight(item.email, shopSearch)">{{ item.email }}</span>
                            (<span v-html="$options.filters.highlight(item.id, shopSearch)">{{ item.id }}</span>)
                          </div>
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </template>
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey q-item-label-font-style">
                      {{ noDataText }}
                    </q-item-section>
                  </q-item>
                </template>
              </q-select>
            </el-col>
            <el-col :span="6">
              <el-checkbox label="ร้านค้าทั้งหมด" border v-model="selectAllShopSearch" @change="changeSelectAllShop" :disabled="onsearchDisable"></el-checkbox>
            </el-col>
            <el-col :span="4" class="text-md-right">
              <el-select v-model="orderType" placeholder="Order Type" :disabled="onsearchDisable">
                <el-option
                  v-for="item in OrderTypeUtility"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id">
                </el-option>
            </el-select>
        </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-bottom: 20px;">
      <el-col :span="24">
        <el-input
          style="width: 100%;"
          v-model="searchText"
          :disabled="onsearchDisable"
          @input="onSearchText"
          placeholder="เลขออเดอร์, เลขแทร๊กกิ้ง, ชื่อ, เบอร์โทร, สถานะการจ่ายเงิน, ปริ้นท์ (พิมพ์ print, noprint), ผู้จัดส่ง"
          @keyup.enter.native="fetchOrder"
        ></el-input>
      </el-col>
    </el-row>
     <el-row :gutter="20">
      <el-col :span="16">
        <el-date-picker
          v-model="datePick"
          :disabled="onsearchDisable"
          type="daterange"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          style="width: 100%;"
        ></el-date-picker>
      </el-col>
      <el-col :span="8">
        <el-button type="primary" style="margin-left:0px;width: 100%;" @click="fetchOrder" :loading="loading">ค้นหา</el-button>
      </el-col>
    </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :md="20" class="navBtn">
        <btn-payment-type :orderCount="count" @selectBtn="setBtn" @selectBtnOnFirstOpenPage="setBtnOnFirstOpenPage"/>
      </el-col>
      <el-col :md="4">

        <el-button type="warning" @click="exportOrder" style="margin-top:10px;" :disabled="onsearchDisable">Export</el-button>
        <el-button type="success" @click="PrintLabel" style="margin-top:10px;" :disabled="selectAllShopSearch">Print Shipping Label</el-button>
      </el-col>
    </el-row>
    <br>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-table
          ref="OrderList"
          :data="orderResult"
          :header-cell-style="{'background-color': 'black', 'color': 'white'}"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="เลขออเดอร์" width="150">
            <template slot-scope="scope">
              <a
                href="#"
                @click="handleOrderNumberDetail(scope.row.orderNumber)"
              >{{ scope.row.orderNumber }}</a>
              <span style="color:rgb(193, 39, 45)" v-if="scope.row.oldOrderId !== null"> (เก่า) <span v-if="scope.row.isAgent === true">(ตัวแทน)</span></span>
            </template>
          </el-table-column>
          <el-table-column label="เลขแทรคกิ้ง" width="150">
            <template slot-scope="scope">
              <a
                v-if="scope.row.courierId === 1"
                target="_blank"
                :href="'https://www.scgexpress.co.th/tracking/?tracking_search=' +  (scope.row.trackingNumber === '' ? GetSCGTrackingNumber(scope.row.orderNumber, scope.row.paymentType === 2) : scope.row.trackingNumber)"
              >{{ scope.row.trackingNumber === '' || scope.row.trackingNumber === null ? GetSCGTrackingNumber(scope.row.orderNumber, scope.row.paymentType === 2) : scope.row.trackingNumber }}</a>
              <a
                v-else-if="scope.row.courierId === 4"
                target="_blank"
                :href="'https://www.flashexpress.co.th/tracking?se=' +  scope.row.trackingNumber"
              >{{ scope.row.trackingNumber }}</a>
              <a
                v-else-if="scope.row.courierId === 9"
                target="_blank"
                :href="'https://www.best-inc.co.th/track?bills=' +  scope.row.trackingNumber"
              >{{ scope.row.trackingNumber }}</a>
              <span
                v-else-if="scope.row.courierId === 2"
              >{{ scope.row.trackingNumber === '' || scope.row.trackingNumber === null ? ("THBRA" + scope.row.orderNumber) : scope.row.trackingNumber }}</span>
              <span v-else>{{ scope.row.trackingNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="เบอร์โทร">
            <template slot-scope="scope">{{ scope.row.shippingPhoneNumber }}</template>
          </el-table-column>
          <el-table-column label="ชื่อลูกค้า" width="150">
            <template slot-scope="scope">{{ scope.row.shippingName }}</template>
          </el-table-column>
          <el-table-column label="ราคา">
            <template slot-scope="scope">{{ scope.row.netPrice | currency('', ',', 2, '.') }}</template>
          </el-table-column>
          <el-table-column label="การชำระเงิน">
            <template slot-scope="scope">
              <el-tag type="success">{{ getPaymentTypeEn(scope.row.paymentType) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="วันที่สร้าง" width="170">
            <template
              slot-scope="scope"
            >{{ scope.row.createdAt | dayjs('format', 'DD-MM-YYYY HH:mm:ss') }}</template>
          </el-table-column>
          <el-table-column label="ปริ้นท์" width="70">
            <template slot-scope="scope">
              <b v-if="scope.row.isPrint">
                <i class="el-icon-check" style="color:green;font-weight: bold;font-size: 20px;"></i>
              </b>
              <b v-else>
                <i class="el-icon-close" style="color:red;font-weight: bold;font-size: 20px;"></i>
              </b>
              <b v-if="scope.row.isReprint">
                <i class="el-icon-refresh-right" style="color:#3d75ff;font-weight: bold;font-size: 20px;"></i>
              </b>
            </template>
          </el-table-column>
          <el-table-column label="สถานะ">
            <template slot-scope="scope">
              {{ getOrderStatus(scope.row.status) }}
              <span
                v-if="scope.row.deletedAt"
                style="color: red;"
              >(ลบ)</span>
            </template>
          </el-table-column>
          <el-table-column label="ผู้จัดส่ง">
            <template slot-scope="scope">
              <el-tag
                v-bind:style="getCourierObject(scope.row.courierId).styleTag"
              >{{ getCourier(scope.row.courierId) }}</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Shipment">
            <template slot-scope="scope">
              <b v-if="scope.row.shipmentStatus === 1">
                <i class="el-icon-check" style="color:green;font-weight: bold;font-size: 20px;"></i>
              </b>
              <b v-else-if="scope.row.shipmentStatus === 2">
                <i class="el-icon-close" style="color:red;font-weight: bold;font-size: 20px;"></i>
              </b>
              <b v-else-if="scope.row.shipmentStatus === 0">
                <i class="el-icon-minus" style="color:black;font-weight: bold;font-size: 16px;"></i>
              </b>
            </template>
          </el-table-column> -->
          <el-table-column label="ตัวแทน">
            <template slot-scope="scope">{{ (scope.row.isAgent)? scope.row.agentName : '-' }}</template>
          </el-table-column>
           <el-table-column label="ชื่อร้าน" v-if="selectAllShopSearch">
            <template slot-scope="scope">{{scope.row.shopName}}</template>
          </el-table-column>
          <el-table-column type="expand" label>
            <template slot-scope="props">
              <el-row :gutter="20">
                <el-col :span="18" :offset="3">
                  <el-table
                    :data="props.row.products"
                    :header-cell-style="{'background-color': 'teal', 'color': 'white'}"
                    style="width: 100%"
                  >
                    <el-table-column prop="sku" label="หมายเลขสินค้า"></el-table-column>
                    <el-table-column prop="name" label="ชื่อสินค้า" width="180"></el-table-column>
                    <el-table-column prop="weight" label="น้ำหนัก (กรัม)"></el-table-column>
                    <el-table-column prop="price" label="ราคาสินค้า"></el-table-column>
                    <el-table-column prop="quantity" label="จำนวน"></el-table-column>
                    <el-table-column prop="discount" label="ส่วนลด"></el-table-column>
                    <el-table-column label="ยอดรวม">
                      <template
                        slot-scope="props"
                      >{{(props.row.price * props.row.quantity) - props.row.discount | currency}}</template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top:10px">
                <el-col :span="3" :offset="14" class="text-md-right">
                  <b>ค่าส่ง</b>
                </el-col>
                <el-col :span="3" class="text-md-right">{{props.row.deliveryCost | currency}}</el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top:10px">
                <el-col :span="3" :offset="14" class="text-md-right">
                  <b>ส่วนลดเพิ่มเติม</b>
                </el-col>
                <el-col :span="3" class="text-md-right">{{props.row.additionalDiscount | currency}}</el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top:10px">
                <el-col :span="3" :offset="14" class="text-md-right">
                  <b>ยอดรวม</b>
                </el-col>
                <el-col :span="3" class="text-md-right">{{props.row.netPrice | currency}}</el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top:10px">
                <el-col :span="3" :offset="3">
                  <b>ที่อยู่ :</b>
                </el-col>
                <el-col
                  :span="16"
                >{{props.row.customer.address}} ตำบล/แขวง {{props.row.customer.subDistrict}} อำเภอ/เขต {{props.row.customer.district}} จังหวัด {{props.row.customer.province}}</el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top:10px">
                <el-col :span="3" :offset="3">
                  <b>รหัสไปรษณีย์ :</b>
                </el-col>
                <el-col :span="16">{{props.row.customer.zipcode}}</el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top:10px">
                <el-col :span="3" :offset="3">
                  <b>เบอร์โทรสำรอง :</b>
                </el-col>
                <el-col :span="16">{{props.row.customer.phoneNumberSec}}</el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top:10px">
                <el-col :span="3" :offset="3">
                  <b>หมายเหตุ :</b>
                </el-col>
                <el-col :span="16">{{props.row.note}}</el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top:10px">
                <el-col :span="3" :offset="3">
                  <b>FACEBOOK/LINE :</b>
                </el-col>
                <el-col :span="16">
                  <template v-if="props.row.oldOrderId !== null">{{props.row.tag}}</template>
                  <template v-else>{{props.row.customer.tag}}</template>
                </el-col>
              </el-row>
              <el-row :gutter="20" style="margin-top:10px">
                <el-col :span="3" :offset="3">
                  <b>ช่องทางการติดต่อ :</b>
                </el-col>
                <el-col :span="16">{{ getPurchaseChannel(props.row.purchaseChannel) }}</el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col style="margin-top:10px;">
        <el-pagination
          @size-change="changeLimitPage"
          @current-change="changeCurrentPage"
          :current-page.sync="pagination.currentPage"
          :page-sizes="pagination.pageSizes"
          :page-size="10"
          layout="prev, pager, next, sizes"
          :total="pagination.allPage * pagination.limit"
        ></el-pagination>
      </el-col>
    </el-row>
    <dialog-export
      :dialogShow="dialogExport"
      :orderCount="count"
      :orderSelect="orderSelected"
      :shopDetail="shopDetail"
      :datePick="datePick"
      :orderType="orderType"
      :shopIdSelected="shopIdExportOrder"
      @closeDialog="dialogExport = false"
    />
  </div>
</template>
<script>
import Vue from 'vue'
import fgApi from '@/services/fillgoods'
import BtnPaymentType from '@/components/OrderManage/btnPaymentType'
import DialogExport from '@/components/OrderManage/dialogExport'
Vue.filter('highlight', function (words, query) {
    var iQuery = new RegExp(query, 'ig')
    return words.toString().replace(iQuery, function (matchedTxt, a, b) {
        return ('<span style=\'background: yellow; font-weight: bold;\' class=\'highlight\'>' + matchedTxt + '</span>')
    })
})
export default {
    name: 'OrderManage',
    components: { BtnPaymentType, DialogExport },
    data () {
        return {
            onsearchDisable: false,
            datePick: null,
            shopSearch: '',
            resultSearchList: [],
            searchText: '',
            loadingSearch: false,
            selectData: {},
            BtnSelect: null,
            orderResult: [],
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            loading: false,
            count: {
                allPaymentCount: {
                    claim: 0,
                    cod: 0,
                    transfer: 0,
                    waiting: 0
                },
                pendingCount: {
                    all: 0,
                    claim: 0,
                    cod: 0,
                    transfer: 0,
                    waiting: 0
                },
                status: {
                    all: 0,
                    codRemited: 0,
                    completed: 0,
                    delivered: 0,
                    failedToDelivery: 0,
                    inTransit: 0,
                    outForDelivery: 0,
                    pending: 0,
                    prepareToShip: 0,
                    readyToShip: 0,
                    returned: 0,
                    shipped: 0,
                    unknown: 0
                }
            },
            dialogExport: false,
            orderSelected: [],
            shopDetail: {},
            timeout: null,
            timeoutSearchShop: null,
            selectAllShopSearch: false,
            shopIdExportOrder: null,
            orderType: 0,
            allShopData: [],
            noDataText: ''
        }
    },
    created () {
        let dateTo = new Date()
        let dateFrom = new Date()
        dateFrom.setDate(dateTo.getDate() - 7)
        this.datePick = [dateFrom, dateTo]
    },
    watch: {
        shopSearch (val) {
            // this.fetchOrder()
        }
    },
    filters: {
        highlightText: function (value) {
            return value.replace(value, '<span class=\'highlight\'>' + value + '</span>')
        }
    },
    methods: {
        changeLimitPage (val) {
            this.pagination.limit = val
            this.fetchOrder()
        },
        changeCurrentPage (val) {
            this.pagination.offset = this.pagination.currentPage * this.pagination.limit - this.pagination.limit
            this.fetchOrder()
        },
        changeSelectAllShop () {
            this.searchText = ''
            this.fetchOrder()
        },
        async remoteMethodSearchShop (text, update) {
            this.shopSearch = text
            let allData = []
            if (text === '') {
                this.noDataText = 'กรุณาพิมพ์ข้อความเพื่อค้นหา'
                this.loadingSearch = false
            } else {
                this.loadingSearch = true
                let param = {
                    search: text
                }
                let resSearch = await fgApi.shop.searchOrderManage(param)
                if (resSearch.success && resSearch.data.length < 1) {
                    this.noDataText = 'ไม่มีข้อมูล'
                } else {
                    allData = resSearch.data
                }
                this.loadingSearch = false
            }

            update(() => {
                this.allShopData = allData
            })
        },
        fetchOrder () {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(async () => {
                this.clearParams()
                let dateFrom = ''
                let dateTo = ''
                if (this.datePick === null) {
                    dateFrom = ''
                    dateTo = ''
                } else {
                    dateFrom = this.datePick[0].getFullYear() + '-' + String(this.datePick[0].getMonth() + 1).padStart(2, '0') + '-' + String(this.datePick[0].getDate()).padStart(2, '0') + ' 00:00:00'
                    dateTo = this.datePick[1].getFullYear() + '-' + String(this.datePick[1].getMonth() + 1).padStart(2, '0') + '-' + String(this.datePick[1].getDate()).padStart(2, '0') + ' 23:59:59'
                }

                const param = {
                    shopId: this.selectAllShopSearch ? -1 : this.shopDetail.shopId,
                    offset: this.pagination.offset,
                    limit: this.pagination.limit,
                    search: this.searchText,
                    from: dateFrom,
                    to: dateTo,
                    status: parseInt(this.BtnSelect[0]),
                    paymentType: parseInt(this.BtnSelect[1]),
                    onlyDeleted: false,
                    orderType: this.orderType
                }
                if (this.datePick === null) {
                    delete param.from
                    delete param.to
                }
                param['order_array'] = null
                if (param.search.indexOf(' ') > -1) {
                    let arrParmSearch = param.search.split(' ')
                    if (arrParmSearch.length > 1) {
                        if (arrParmSearch[1].length !== 0 && arrParmSearch[1] !== '') {
                            if (arrParmSearch.length > 1) {
                                param['order_array'] = arrParmSearch.filter(e => e !== '').map((e) => e.trim())
                            } else {
                                param['order_array'] = null
                            }
                        }
                    }
                }
                this.loading = true
                this.onsearchDisable = true
                if (this.selectAllShopSearch) {
                    try {
                        let res = await fgApi.log.OrderSearchShopId(param)
                        this.orderResult = res.data
                        this.pagination.allPage = res.allPage
                        this.count.allPaymentCount = res.allPaymentCount
                        this.count.pendingCount = res.pendingCount
                        this.count.status = res.status
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    if (this.shopDetail.hasOwnProperty('shopId') && this.shopSearch !== '') {
                        try {
                            let res = await fgApi.log.OrderSearchShopId(param)
                            this.orderResult = res.data
                            this.pagination.allPage = res.allPage
                            this.count.allPaymentCount = res.allPaymentCount
                            this.count.pendingCount = res.pendingCount
                            this.count.status = res.status
                        } catch (error) {
                            console.log(error)
                        }
                    } else {
                        this.$notify({
                            title: 'Warning',
                            message: 'กรุณาเลือกร้าน',
                            type: 'warning'
                        })
                    }
                }

                this.loading = false
                this.onsearchDisable = false
            }, 500)
        },
        setBtnOnFirstOpenPage (val) {
            this.BtnSelect = val
        },
        setBtn (val) {
            this.BtnSelect = val
            this.fetchOrder()
        },
        onSearchText (val) {
            this.pagination.offset = 0
            this.searchText = val
            this.fetchOrder()
        },
        exportOrder () {
            this.shopIdExportOrder = this.selectAllShopSearch ? -1 : this.shopDetail.shopId
            if (this.shopIdExportOrder) {
                this.dialogExport = !this.dialogExport
            } else {
                this.$message({
                    message: 'กรุณาเลือกร้านค้า หรือ เลือกร้านค้าทั้งหมด',
                    type: 'warning'
                })
            }
        },
        handleSelectionChange (val) {
            this.orderSelected = val
        },
        handleSelect (item) {
            this.shopSearch = `${item.name} - ${item.email} (${item.id})`
            this.shopDetail = { shopId: item.id, isShowShopAddress: item.isShowShopAddress }
            this.fetchOrder()
        },
        async PrintLabel () {
            // printOrder

            if (this.orderSelected.length > 0) {
                this.$loading()
                let mapData = this.orderSelected.map(e => String(e.orderId))
                let param = {
                    orders_id: mapData,
                    is_show_shop_address: this.shopDetail.isShowShopAddress
                }
                try {
                    let res = await fgApi.payment.printOrder(param)
                    if (res.success) {
                        const urlPrint = mode => {
                            if (mode === 'production') {
                                return 'https://app.fillgoods.co/app/'
                            } else if (mode === 'uat') {
                                return 'https://uat.fillgoods.me/app/'
                            } else if (mode === 'dev') {
                                return 'https://dev.fillgoods.me/app/'
                            }
                        }
                        window.open(
                            urlPrint(this.$store.get('envSystem/mode')) +
                'label?keyUse=' +
                res.keyUse
                        )
                    } else {
                        this.$message({
                            message: res,
                            type: 'error'
                        })
                    }
                } catch (error) {
                    this.$message({
                        message: error,
                        type: 'error'
                    })
                }
                this.$loading().close()
            } else {
                this.$message({
                    message: 'ไม่พบรายการออเดอร์ที่เลือก',
                    type: 'warning'
                })
            }
        },
        handleOrderNumberDetail (orderNumber) {
            let route = this.$router.resolve({
                path: `/oms/logOrder/LogOrderDetail`,
                query: { orderId: orderNumber }
            })
            window.open(route.href, '_blank') // New tab
        },
        clearParams () {
            this.orderResult = []
            this.count = {
                allPaymentCount: {
                    claim: 0,
                    cod: 0,
                    transfer: 0,
                    waiting: 0
                },
                pendingCount: {
                    all: 0,
                    claim: 0,
                    cod: 0,
                    transfer: 0,
                    waiting: 0
                },
                status: {
                    all: 0,
                    codRemited: 0,
                    completed: 0,
                    delivered: 0,
                    failedToDelivery: 0,
                    inTransit: 0,
                    outForDelivery: 0,
                    pending: 0,
                    prepareToShip: 0,
                    readyToShip: 0,
                    returned: 0,
                    shipped: 0,
                    unknown: 0
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.OrderDetail {
  font-size: 8px !important;
  border-collapse: collapse;
  width: 100%;
  th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: teal;
    color: white;
  }
  td,
  th {
    border: 1px solid #ddd;
    padding: 8px;
  }
  tr:hover {
    background-color: unset !important;
  }

  .fas {
    cursor: pointer;
  }
  .el-button--mini {
    padding: 4px 8px;
    font-size: 9px;
    border-radius: 3px;
  }
}
.highlight {
  font-weight: bold;
  background: yellow;
}
.q-select-search-all-shop{
  width: 100%;
}
.q-item-label-font-style {
  font-family: 'Prompt', sans-serif !important;
}
::v-deep .q-field__control {
  max-height: 40px;
  min-height: 40px;
  .q-field__native {
    max-height: 40px;
    min-height: 40px;
  }
}
::v-deep .q-field__marginal {
  max-height: 40px;
  min-height: 40px;
}
.q-select-search-all-shop-option {
  width: 100%;
}
.q-item-label-text-overflow {
  white-space: nowrap;
  width: 450px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
